var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 200,
    viewBox: "0 0 387 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3614_586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.015 31.1262L69.6042 0.441595C65.9686 -0.752988 61.9825 0.532273 59.7215 3.62321L1.70179 83.061C-0.555195 86.1519 -0.567012 90.3468 1.67027 93.4495L59.2213 173.23C61.4586 176.333 65.4408 177.642 69.0843 176.471L85.4464 171.204C88.4478 170.238 91.7407 170.948 94.0765 173.069L121.964 198.352C125.591 201.644 131.421 199.767 132.453 194.973L140.386 158.158C141.052 155.071 143.309 152.575 146.314 151.61L162.676 146.342C166.316 145.171 168.789 141.785 168.801 137.957L169.092 39.5553C169.104 35.7271 166.65 32.3247 163.015 31.1341V31.1262Z",
    fill: "#AFCA0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.126 51.9033V129.768H92.9025V97.5103H64.0068V129.768H48.6688V51.9033H64.0068V82.8284H92.9025V51.9033H108.126Z",
    fill: "#004752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.349 58.6883C121.349 53.9061 125.351 49.7901 130.129 49.7901C134.907 49.7901 139.019 53.9061 139.019 58.6883C139.019 63.4706 135.017 67.4762 130.129 67.4762C125.241 67.4762 121.349 63.4706 121.349 58.6883ZM123.015 74.1509H137.353V129.772H123.015V74.1509Z",
    fill: "#004752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.033 66.5852V85.052H232.264V99.7339H202.033V129.768H186.695V51.9033H233.15V66.5852H202.033Z",
    fill: "#004752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.151 58.6883C243.151 53.9061 247.153 49.7901 251.931 49.7901C256.709 49.7901 260.821 53.9061 260.821 58.6883C260.821 63.4706 256.819 67.4762 251.931 67.4762C247.043 67.4762 243.151 63.4706 243.151 58.6883ZM244.817 74.1509H259.155V129.772H244.817V74.1509Z",
    fill: "#004752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.726 74.1509L304.61 129.772H288.271L267.155 74.1509H282.938L296.385 113.083L309.943 74.1509H325.726Z",
    fill: "#004752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.285 118.311C364.843 118.311 369.286 115.977 371.732 112.748L383.289 119.423C378.066 126.989 369.731 131.325 359.061 131.325C340.39 131.325 328.609 118.532 328.609 101.957C328.609 85.3831 340.501 72.5897 357.95 72.5897C374.399 72.5897 386.066 85.6039 386.066 101.957C386.066 104.071 385.845 105.963 385.51 107.852H343.612C345.613 115.193 351.726 118.307 359.281 118.307L359.285 118.311ZM371.732 96.7297C369.956 88.7224 363.953 85.4935 357.95 85.4935C350.281 85.4935 345.058 89.6095 343.392 96.7297H371.732Z",
    fill: "#004752"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3614_586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 386.07,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6709f09aa0ce168ce7bc87bc97609d0c.svg";
export { ForwardRef as ReactComponent };